import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import Spinner from '@ux/spinner';

import ShowHideButton from '../ShowHideButton';
import SecurePassword from '../../secure-password';
import { securePasswordTypesType } from '../../../shared/types';

require('./styles.scss');

const LabelSecurePassword = props => {
  const {
    id,
    type,
    host,
    label,
    focus,
    active,
    isShow,
    onBlur,
    isReady,
    message,
    onFocus,
    isError,
    sso_app,
    sso_port,
    required,
    localize,
    onActive,
    onChange,
    onKeyPress,
    onShowHide,
    isShowHide,
    onAutofill,
    onReadyChange,
  } = props;

  useEffect(() => {
    onReadyChange({ isReady: false, data: {} });

    return () => {
      onReadyChange({ isReady: false, data: {} });
    };
    // Please fix this when you touch this file
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fieldFrameClassNames = ClassNames('ux-field-frame', 'ux-field-frame--stretch', {
    'ux-field-frame--invalid': isError,
  });

  const entryShellClassNames = ClassNames('ux-text-entry-shell', 'ux-text', 'ux-text-input', {
    'ux-text-feedback-critical': isError,
  });

  const labelClassNames = ClassNames('ux-label', 'ux-label--internal', 'custom-label', {
    'ux-label--floating': focus || active,
  });

  const messageClassNames = ClassNames('ux-text', 'ux-text-caption', {
    'ux-text-feedback-critical': isError,
  });

  return (
    <>
      <div className='ux-text-input-shell'>
        <div className={fieldFrameClassNames}>
          <div className={entryShellClassNames}>
            {!isReady ? (
              <div className='overlay'>
                <Spinner size='sm' />
              </div>
            ) : null}
            <label className={labelClassNames}>
              {label}
              {required && (
                <span className='ux-text ux-label-required ux-text-feedback-critical' aria-hidden='true'>
                  *
                </span>
              )}
            </label>
            <SecurePassword
              id={id}
              type={type}
              host={host}
              onBlur={onBlur}
              sso_app={sso_app}
              onFocus={onFocus}
              onActive={onActive}
              sso_port={sso_port}
              onChange={onChange}
              onAutofill={onAutofill}
              onKeyPress={onKeyPress}
              onReadyChange={onReadyChange}
              onError={error => {
                // eslint-disable-next-line no-console
                console.log('error', error);
              }}
              useTextInputStyles
            />
            {isShowHide && (
              <ShowHideButton
                show_text={localize('SHOW')}
                hide_text={localize('HIDE')}
                aria_show_text={localize('SHOW_PASSWORD')}
                aria_hide_text={localize('HIDE_PASSWORD')}
                handleClick={() => onShowHide(!isShow)}
                show_password={isShow}
              />
            )}
          </div>
        </div>
        {message && (
          <p className={messageClassNames} id='username-error' role='alert'>
            {message}
          </p>
        )}
      </div>
    </>
  );
};

LabelSecurePassword.defaultProps = {
  sso_app: 'origin-sso-ui',
  sso_port: '',
  isShowHide: true,
};

LabelSecurePassword.propTypes = {
  id: PropTypes.string.isRequired,
  type: securePasswordTypesType.isRequired,
  host: PropTypes.string,
  label: PropTypes.string.isRequired,
  focus: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  isShow: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired,
  isReady: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onFocus: PropTypes.func.isRequired,
  sso_app: PropTypes.string,
  isError: PropTypes.bool.isRequired,
  sso_port: PropTypes.string,
  required: PropTypes.bool.isRequired,
  localize: PropTypes.func.isRequired,
  onActive: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onAutofill: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onShowHide: PropTypes.func.isRequired,
  isShowHide: PropTypes.bool,
  onReadyChange: PropTypes.func.isRequired,
};

export default LabelSecurePassword;
